import * as React from 'react';
import { SVGProps } from 'react';

const SvgUploadOutlined = (props: SVGProps<SVGSVGElement>) => (
  <svg width={24} height={24} viewBox="0 0 24 24" fill="none" role="img" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4 13.8c.497 0 1 .403 1 .9v3.4a.9.9 0 0 0 .9.9h12.2a.9.9 0 0 0 .9-.9v-3.4c0-.497.503-.9 1-.9s1 .403 1 .9v3.6a2.7 2.7 0 0 1-2.7 2.7H5.7A2.7 2.7 0 0 1 3 18.3v-3.6c0-.497.503-.9 1-.9ZM16.756 8.749a.817.817 0 0 1-1.179 0L12 5.069 8.423 8.75a.817.817 0 0 1-1.179 0 .875.875 0 0 1 0-1.212l4.167-4.286a.817.817 0 0 1 1.178 0l4.167 4.286a.874.874 0 0 1 0 1.212Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12 15.6a.9.9 0 0 1-.9-.9V3.9a.9.9 0 0 1 1.8 0v10.8a.9.9 0 0 1-.9.9Z"
      fill="currentColor"
    />
  </svg>
);

export default SvgUploadOutlined;
